import React, { Component } from 'react';

import GlobalHelper from '../../../../Common/Helpers/GlobalHelper';

class DatosAutorizacionesRechazadas extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const {autorizaciones}=this.props;

        return (
            
                <div className="contenedorDatosIntegranteCuenta">
                    <div className='CuentaSeleccionContainer'></div>
                    <div className='CuentaSeleccionContainer'>
                        <div className="columnaDatosAutorizacionesLeft">
                            <div className="">
                                <div className="InfoIntegrantes">IVA Servicios Digitales:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.ImporteIVAServDigitales}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Impuesto País:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.ImporteImpuestoPais}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">RG 4815:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.ImporteImpuestoRG4815}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Importe Total en Pesos:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.ImporteTotalPesos}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Tipo Movimiento:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.TipoMovimiento}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Cuotas:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.Cuotas}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Origen:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.Origen}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Regla Fraude:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.ReglaFraude}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">ICA:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.ICA}</div>
                            </div>
                        </div>
                        <div className="columnaDatosAutorizacionesRight">
                            <div className="">
                                <div className="InfoIntegrantes">Establecimiento:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.Establecimiento}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">TCC:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.TCC}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Rubro Comercio:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.RubroComercio}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Forzada:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.Forzada}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Modo Entrada:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.ModoEntrada}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Terminal POS:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.TerminalPOS}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Usuario:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.Usuario}</div>
                            </div>
                            <div className="">
                                <div className="InfoIntegrantes">Standin:</div>
                                <div className="InfoDatoIntegrantes">{autorizaciones.Standin}</div>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }
}

export default DatosAutorizacionesRechazadas;